import { chatbotParamsDefaultValues } from "@do/shared-types";
import { useChat } from "../providers/chat-provider";

/**
 * Whether the chat may play its decorative animations.
 *
 * Hosts that mount `ChatProvider` directly (the crai-office theme editor preview)
 * skip the default merge `Chat` performs, so fall back to the shared default rather
 * than treating an absent flag as "off".
 */
export const useMotionEnabled = (): boolean => {
  const { chatbotParams } = useChat();

  return chatbotParams.motionEnabled ?? chatbotParamsDefaultValues.motionEnabled;
};
